import { CRUDEntity } from "../abstracts/CRUDEntity";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { Filterable } from "../abstracts/mixins/Filterable";
import { FormActions } from "../abstracts/mixins/FormActions";
import { HasAttachments } from "../abstracts/mixins/HasAttachments";
import { HasComments } from "../abstracts/mixins/HasComments";
import { HasStatus } from "../abstracts/mixins/HasStatus";
import { HasWorkers } from "../abstracts/mixins/HasWorkers";

export const Visit = (() => {

    return class Visit extends CRUDEntity {

        static #statuses = {
            SHEDULED: 1,
            IN_PROGRESS: 2,
            COMPLETED: 3,
            CANCELED: 4
        }

        static get statuses(){
            return this.#statuses
        }

        constructor(id=null) {
            super();
            this.entityClass = 'visit';
            this.urlRoot = /worker-cabinet/.test(location.href.split(/[\\\/]+/).pop()) ? '/worker-cabinet/visit' : '/jobs-flow/visit';
            this.sectionRootUrl = /worker-cabinet/.test(location.href.split(/[\\\/]+/).pop()) ? '/worker-cabinet' : '/jobs-flow';
            this.id = id;

            Object.assign(Visit.prototype, FormActions);
            Object.assign(Visit.prototype, EntityModalForm);
            Object.assign(Visit.prototype, HasStatus);
            Object.assign(Visit.prototype, HasWorkers);
            Object.assign(Visit.prototype, HasComments);
            Object.assign(Visit.prototype, HasAttachments);
           
            Visit.prototype.collectDataInForm = function(formId) {
                let data = FormActions.collectDataInForm(formId);
                data.workers = this.collectWorkersInForm();
                return data;
            }

            Visit.prototype.completeForm = function(formId, info=null, self=null) {
                const info_arr = Object.assign(this.read(), info);
                HasWorkers.completeForm(formId, info_arr, this);

                if (info_arr && info_arr.worker_comments) {
                    JSON.parse(info_arr.worker_comments).forEach(element => {
                        $('#worker_comments_container').append(`<div class="mt-2">${element}</div>`)
                    });
                }
            }

           
            this.setAttachmentCallbackPreview();
        }
    }
})();
